import { Theme } from "../../../components/constants";

export default {
	lableText: {
		fontSize: "20px",
	},

	selectAllCBox: {
		margin: "10px 0 0 0"
	},

	dropdownGroup:{
		display:"flex",
		alignItems:"center",
		columnGap: "5%",
    	flexWrap: "wrap",
	},
	calendarBox: {
		width: '100%',
		display: "flex",
		justifyContent: "space-between",
		margin: "10px 0 35px"
	},
	editActionsRow: {
		display: 'flex',
		gap: '20px',
	},
	editBox: {
		width: '100%',
		display: "flex",
		justifyContent: "space-between",
		margin: "10px 0 35px"
	},
	editBoxInputWidth:{
		width: '45%',
	},
	calendar: {
		width: "45%"
	},

	extensionContainer: {
		display: "flex",
		margin: "10px 0 35px",
		columnGap: "25px"
	},

	horizontalLine: {
		margin: "20px 0 20px"
	},

	checkboxContainer: {
		width: '50%',
		display: "grid",
		gridTemplateColumns: "repeat(2, 1fr)",
		gridGap: "20px",
	},
	text: {
		fontSize: "14px",
		color: Theme.TEXT_PRIMARY_BLACK
	},
	noticeRow: {
		display: 'flex',
		gap: '10px',
		flexDirection: 'column',
		paddingBottom: '20px'
	},
	customMultiSelect: {
		maxHeight: '200px',
		overflowY: 'auto',
		overflowX: 'hidden'
	},
	buttonRow: {
		display: 'flex', 
		gap: '30px',
		alignItems: 'center',
		marginTop: '30px',
	},
	customPopupSyles: {
		height: '80vh', 
		width: '50vw', 
		maxWidth: '50vw'
	},
	childrenStyles: {
		padding: '40px 100px', 
		height: 'calc(100% - 87px)'
	},
	exportForMultipleExport: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '90%',
	}
}